'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _flattenDeep = require('lodash/flattenDeep');

var _flattenDeep2 = _interopRequireDefault(_flattenDeep);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _reduce = require('lodash/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _InputLabel = require('@material-ui/core/InputLabel');

var _InputLabel2 = _interopRequireDefault(_InputLabel);

var _Select = require('@material-ui/core/Select');

var _Select2 = _interopRequireDefault(_Select);

var _Checkbox = require('../Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Dropdown = require('../Dropdown');

var _FormControl = require('../FormControl');

var _FormControl2 = _interopRequireDefault(_FormControl);

var _EDSContext = require('../EDSContext/EDSContext');

var _IOSBodyScroll = require('./../IOSBodyScroll');

var _IOSBodyScroll2 = _interopRequireDefault(_IOSBodyScroll);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _tokens = require('../styles/tokens');

var _ChevronDown = require('@eui/ds-icons/lib/ChevronDown');

var _ChevronDown2 = _interopRequireDefault(_ChevronDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// MUI imports


// select all selection states
var ALL = 0;
var INDETERMINATE = 1;
var NONE = 2;

var styles = function styles(theme) {
    return {
        select: {
            backgroundColor: theme.palette.grey['100'],
            '&$disabled': {
                backgroundColor: theme.palette.grey['200'],
                cursor: 'not-allowed'
            },
            '&:focus': {
                backgroundColor: theme.palette.grey['100'],
                borderRadius: _tokens.borderRadiusMedium,
                boxShadow: _tokens.boxShadowFocus
            }
        },
        selectIcon: {
            '&:hover': {
                '& $icon': {
                    fill: theme.palette.ctaColor.active
                }
            }
        },
        paper: {
            border: _tokens.borderWidthThin + ' solid ' + theme.palette.grey[400],
            boxShadow: '0 0.125rem 0.0625rem -0.0625rem rgba(0, 0, 0, 0.12), 0 0.0625rem 0.0625rem 0 rgba(0, 0, 0, 0.14), 0 0.0625rem 0.1875rem 0 rgba(0, 0, 0, 0.21)'
        },
        selectMenu: {
            border: _tokens.borderWidthThin + ' solid ' + theme.palette.grey['400'],
            borderRadius: _tokens.borderRadiusMedium,
            lineHeight: '1.3rem',
            padding: _tokens.spacingMedium + ' 3.5rem ' + _tokens.spacingXSmall + ' ' + _tokens.spacingSmall,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        nativeSelect: {
            backgroundColor: theme.palette.grey['100'],
            border: _tokens.borderWidthThin + ' solid ' + theme.palette.grey['400'],
            borderRadius: _tokens.borderRadiusMedium,
            padding: _tokens.spacingMedium + ' 3.5rem ' + _tokens.spacingXSmall + ' ' + _tokens.spacingSmall,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: 'calc(100% - 4.625rem)',
            height: 'auto',
            '&$disabled': {
                backgroundColor: theme.palette.grey['200'],
                cursor: 'not-allowed'
            },
            '&:focus': {
                backgroundColor: theme.palette.grey['100'],
                borderRadius: _tokens.borderRadiusMedium,
                boxShadow: _tokens.boxShadowFocus
            }
        },
        icon: {
            right: _tokens.spacingSmall,
            top: '1.1875rem',
            fill: theme.palette.grey['500']
        },
        inputLabelRoot: {
            fontSize: _tokens.fontSizeLarge,
            color: theme.palette.grey['500'],
            left: '1.0625rem',
            top: '-0.375rem',
            zIndex: theme.zIndex.textFieldLabel,
            pointerEvents: 'none'
        },
        inputLabelShrink: {
            top: _tokens.spacingXSmall
        },
        disabled: {
            cursor: 'not-allowed'
        },
        zIndex: {
            zIndex: theme.zIndex.dropdown + 1
        },
        small: {
            fontSize: _tokens.fontSizeDefault,
            '& $icon': {
                top: _tokens.spacingXSmall2
            },
            '& $inputLabelRoot': {
                top: '-' + _tokens.spacingXSmall2,
                fontSize: _tokens.fontSizeDefault
            },
            '& $selectMenu': {
                padding: '\n                ' + _tokens.spacingXSmall1 + '\n                3.5rem\n                ' + _tokens.spacingXSmall1 + '\n                ' + _tokens.spacingXSmall1 + '\n            ',
                lineHeight: 'unset'
            },
            '& $nativeSelect': {
                padding: _tokens.spacingXSmall1 + ' 3.5rem ' + _tokens.spacingXSmall1 + ' ' + _tokens.spacingXSmall1,
                lineHeight: 'unset'
            }
        },
        inputLabelSmall: {
            top: '-' + _tokens.spacingXSmall2,
            left: _tokens.spacingXSmall2,
            fontSize: _tokens.fontSizeDefault,
            '&[data-shrink=true]': {
                display: 'none'
            }
        },
        error: {
            border: _tokens.borderWidthThick + ' solid ' + theme.palette.status.error.fill,
            '&:focus': {
                boxShadow: '0 0 0 ' + _tokens.borderWidthThin + ' ' + _tokens.colorFillAlertError,
                '-webkit-box-shadow': '0 0 0 ' + _tokens.borderWidthThin + ' ' + _tokens.colorFillAlertError,
                '-moz-box-shadow:': '0 0 0 ' + _tokens.borderWidthThin + ' ' + _tokens.colorFillAlertError
            }
        },
        ffErrorTextAdjuster: {
            '-moz-transform': 'translateY(-' + _tokens.spacingSmall + ')'
        },
        formControlWidth: {
            maxWidth: _tokens.widthInputFields
        }
    };
};

var menuListClassName = 'menu-list';

/**
 * Use `Dropdown` to make selections from a list.
 * @done true
 * @updated true
 * @versionAdded v0.0.10
 * @examples
 *  ControlledDropdownExample
 *  ErrorDropdownExample
 *  FullWidthDropdownExample
 *  IconDropdownExample
 *  LongTextDropdownExample
 *  MultiSelectDropdownExample
 *  SelectAllDropdownExample
 *  PerformanceTestDropdownExample
 *  NativeExample
 */

var Dropdown = function (_React$Component) {
    _inherits(Dropdown, _React$Component);

    function Dropdown(props) {
        _classCallCheck(this, Dropdown);

        // the internal value of the 'select all' item
        var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

        _this.onDropDownOpen = function (e) {
            var onOpen = _this.props.onOpen;


            _IOSBodyScroll2.default.lock('.' + menuListClassName);
            onOpen && onOpen(e);
        };

        _this.onDropDownClose = function (e) {
            var onClose = _this.props.onClose;


            _IOSBodyScroll2.default.unlock();
            onClose && onClose(e);
        };

        _this.selectAllValue = (0, _v2.default)();

        _this.state = {
            selectionState: NONE,
            allItems: {}
        };

        _this.onDropDownOpen = _this.onDropDownOpen.bind(_this);
        _this.onDropDownClose = _this.onDropDownClose.bind(_this);
        return _this;
    }

    /**
     * Called when the dropdown value changes
     *
     * @param {Event} event   The event that spurred this callback
     * @param {object} child  The react element that was selected
     */


    _createClass(Dropdown, [{
        key: 'handleChange',
        value: function handleChange(event, child) {
            var _this2 = this;

            // if the user click the 'select all' item in a multi-select dropdown
            if (this.props.multiple && event.target.value.indexOf(this.selectAllValue) > -1) {
                // if no items are selected, select everything; otherwise unselect everything
                var newState = this.state.selectionState === NONE ? ALL : NONE;

                // set the new select all state
                this.setState({ selectionState: newState }, function () {
                    // either select or unselect everything (overriding the value in the
                    // event with the results of doing so)
                    if (_this2.state.selectionState === ALL) {
                        event.target.value = Object.keys(_this2.state.allItems);
                    } else {
                        event.target.value = [];
                    }

                    // let the caller know
                    _this2.props.onChange && _this2.props.onChange(event, child);
                });
            } else {
                this.props.onChange && this.props.onChange(event, child);
            }
        }

        /**
         * Grab the label/value of each item
         */

    }, {
        key: 'objectifyItems',
        value: function objectifyItems() {
            // grab all the dropdown items

            var filteredDropdownItems = (0, _filter2.default)((0, _flattenDeep2.default)(this.props.children), function (item) {
                return (0, _get2.default)(item, 'type.muiName') === 'DropdownItem';
            });

            return (0, _reduce2.default)(filteredDropdownItems, function (mapping, item) {
                mapping[item.props.value] = item.props.label;
                return mapping;
            }, {});
        }

        /**
         * Render a single value.
         *
         * @param {*} val The value to render
         * @return        The rendered value
         */

    }, {
        key: 'renderSingleValue',
        value: function renderSingleValue(val) {
            return this.state.allItems[val];
        }

        /**
         * Render multiple values.
         *
         * @param {Array.<*>} values The values to render
         * @return                   The rendered values
         */

    }, {
        key: 'renderMultipleValues',
        value: function renderMultipleValues(values) {
            var _this3 = this;

            return values.map(function (val) {
                return _this3.renderSingleValue(val);
            }).join(', ');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // retain a catalog of each dropdown item
            this.setState({
                allItems: this.objectifyItems()
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // if the list of items has changed, update our internal catalog
            var itemsHaveChanged = (0, _get2.default)(this.props, 'children.length', 0) !== (0, _get2.default)(prevProps, 'children.length', 0) || !(0, _isEqual2.default)(this.objectifyItems(), this.state.allItems);

            if (itemsHaveChanged) {
                this.setState({
                    allItems: this.objectifyItems()
                });
            }

            // if the select-all item is visible, update it based on current selections
            if (this.props.multiple && this.props.showSelectAll) {
                var selectionState = NONE;

                if (this.props.value.length === Object.keys(this.state.allItems).length) {
                    selectionState = ALL;
                } else if (this.props.value.length > 0) {
                    selectionState = INDETERMINATE;
                }

                // if selection state changed, update it
                if (this.state.selectionState !== selectionState) {
                    this.setState({
                        selectionState: selectionState
                    });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames3, _classNames4;

            var _props = this.props,
                childrenProp = _props.children,
                classes = _props.classes,
                disabled = _props.disabled,
                error = _props.error,
                edsContext = _props.edsContext,
                helperText = _props.helperText,
                id = _props.id,
                inputProps = _props.inputProps,
                labelProp = _props.label,
                multiple = _props.multiple,
                required = _props.required,
                value = _props.value,
                size = _props.size,
                onChange = _props.onChange,
                showSelectAll = _props.showSelectAll,
                fullWidth = _props.fullWidth,
                FormControlProps = _props.FormControlProps,
                FormHelperTextProps = _props.FormHelperTextProps,
                rest = _objectWithoutProperties(_props, ['children', 'classes', 'disabled', 'error', 'edsContext', 'helperText', 'id', 'inputProps', 'label', 'multiple', 'required', 'value', 'size', 'onChange', 'showSelectAll', 'fullWidth', 'FormControlProps', 'FormHelperTextProps']);

            var cleanedId = id || (0, _v2.default)();
            var selectLabelId = cleanedId + '_label';

            var newInputProps = Object.assign({}, inputProps, {
                id: cleanedId
            });

            var children = childrenProp;
            var label = labelProp;

            // we do this to handle a bug within MUI - if the initial value is nil, then the label does not correctly
            // shrink out of the way when an item is selected. so we set the initial value to empty string instead, which
            // appears to solve the issue
            var localValue = (0, _isNil2.default)(value) ? '' : value;

            if (multiple) {
                children = _react2.default.Children.map(childrenProp, function (child, index) {
                    return (0, _react.cloneElement)(child, { multiple: true });
                });

                // add the current selection count to the label
                if (localValue && this.state.allItems) {
                    var countString = '(' + this.props.value.length + '/' + Object.keys(this.state.allItems).length + ')';
                    label = labelProp + ' ' + countString;
                }
            }

            return _react2.default.createElement(
                _FormControl2.default,
                Object.assign({
                    className: (0, _classnames2.default)(_defineProperty({}, classes.formControlWidth, !fullWidth))
                }, FormControlProps),
                _react2.default.createElement(
                    _react.Fragment,
                    null,
                    _react2.default.createElement(
                        _InputLabel2.default,
                        {
                            id: selectLabelId,
                            classes: {
                                root: classes.inputLabelRoot,
                                shrink: classes.inputLabelShrink,
                                disabled: (0, _classnames2.default)(classes.disabled, classes.zIndex)
                            },
                            disabled: disabled,
                            htmlFor: cleanedId,
                            className: (0, _classnames2.default)(_defineProperty({}, classes.inputLabelSmall, size === 'small'))
                        },
                        required ? label + ' *' : label
                    ),
                    _react2.default.createElement(
                        _Select2.default,
                        Object.assign({
                            className: (0, _classnames2.default)((_classNames3 = {}, _defineProperty(_classNames3, classes.small, size === 'small'), _defineProperty(_classNames3, classes.selectIcon, !disabled), _classNames3)),
                            classes: {
                                select: (0, _classnames2.default)((_classNames4 = {}, _defineProperty(_classNames4, classes.select, !this.props.native), _defineProperty(_classNames4, classes.nativeSelect, this.props.native), _defineProperty(_classNames4, classes.error, this.props.native && error), _classNames4)),
                                selectMenu: (0, _classnames2.default)(classes.selectMenu, _defineProperty({}, classes.error, error)),
                                icon: classes.icon,
                                disabled: classes.disabled
                            },
                            onChange: this.handleChange.bind(this),
                            disabled: disabled,
                            disableUnderline: true,
                            IconComponent: _ChevronDown2.default,
                            inputProps: newInputProps,
                            'aria-labelledby': selectLabelId,
                            MenuProps: {
                                MenuListProps: {
                                    disablePadding: true,
                                    className: menuListClassName
                                },
                                classes: {
                                    paper: classes.paper
                                }
                            },
                            multiple: multiple,
                            renderValue: multiple ? this.renderMultipleValues.bind(this) : this.renderSingleValue.bind(this),
                            value: localValue
                        }, rest, {
                            onOpen: this.onDropDownOpen,
                            onClose: this.onDropDownClose
                        }),
                        showSelectAll && _react2.default.createElement(
                            _Dropdown.DropdownItem,
                            {
                                label: edsContext.formatMessage('component.Dropdown.selectAll'),
                                selectAll: true,
                                multiple: true,
                                value: this.selectAllValue
                            },
                            _react2.default.createElement(_Checkbox2.default, {
                                indeterminate: this.state.selectionState === INDETERMINATE,
                                checked: this.state.selectionState !== NONE
                            })
                        ),
                        children
                    ),
                    helperText && _react2.default.createElement(
                        _FormControl.FormHelperText,
                        Object.assign({
                            className: size === 'medium' && !this.props.native ? classes.ffErrorTextAdjuster : null,
                            error: error,
                            id: cleanedId + '_HelperText'
                        }, FormHelperTextProps),
                        helperText
                    )
                )
            );
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // Just making sure to unlock the body scroll
            _IOSBodyScroll2.default.unlock();
        }
    }]);

    return Dropdown;
}(_react2.default.Component);

/**
 * The following should be used to enable Tooltip hover once bugs have been tested
 *
    <Tooltip
        disableFocusListener
        enterDelay={1000}
        enterTouchDelay={1000}
        leaveTouchDelay={500}
        id={`${id}_Tooltip`}
        title={multiple ? value.join(', ') : value}
    >
        <Select></Select>
    </Tooltip>
 */

Dropdown.muiName = 'Dropdown';

Dropdown.propTypes = {
    /**
     * If `true`, the width of the popover will automatically be set according to the items inside the
     * menu, otherwise it will be at least the width of the select input.
     */
    autoWidth: _propTypes2.default.bool,
    /**
     * The elements to populate the select with.
     *
     * - If `native` it true, these must be `option` elements
     * - if `native` is false, these must be `DropdownItem` elements
     */
    children: _propTypes2.default.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object.isRequired,
    /**
     * If `true`, the dropdown will be disabled.
     */
    disabled: _propTypes2.default.bool,
    /**
     * If `true`, the selected item is displayed even if its value is empty.
     */
    displayEmpty: _propTypes2.default.bool,
    /**
     * If `true`, the dropdown will display in an error state
     */
    error: _propTypes2.default.bool,
    /**
     * Properties applied to the [`FormControl`](#/components/FormControl) element.
     */
    FormControlProps: _propTypes2.default.object,
    /**
     * Properties applied to the [`FormHelperText`](#/components/FormControl) element.
     */
    FormHelperTextProps: _propTypes2.default.object,
    /**
     * If `true`, the dropdown will take up the full width of its container.
     */
    fullWidth: _propTypes2.default.bool,
    /**
     * Text to be displayed by the FormHelperText component
     */
    helperText: _propTypes2.default.string,
    /**
     * The icon that displays the arrow.
     */
    IconComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]),
    /**
     * Id assigned to the input element and referenced by label element
     */
    id: _propTypes2.default.string,
    /**
     * An `Input` element; does not have to be a material-ui specific `Input`.
     */
    input: _propTypes2.default.element,
    /**
     * Attributes applied to the `input` element. When `native` is `true`,
     * the attributes are applied on the `select` element.
     */
    inputProps: _propTypes2.default.object,
    /**
     * @ignore
     */
    edsContext: _propTypes2.default.object,
    /**
     * Label that is attached to the `Dropdown`
     */
    label: _propTypes2.default.string.isRequired,
    /**
     * Properties applied to the [`Menu`](https://material-ui.com/api/menu/) element.
     */
    MenuProps: _propTypes2.default.object,
    /**
     * If true, `value` must be an array and the menu will support multiple selections.
     * This feature will only work if `native` is `false`.
     */
    multiple: _propTypes2.default.bool,
    /**
     * If `true`, the component will be using a native `select` element.
     * Be sure to use the `option` element to create dropdown items when
     * `native` is set to `true`, instead of our `DropdownItem` component.
     */
    native: _propTypes2.default.bool,
    /**
     * Callback function fired when a menu item is selected.
     *
     * Signature:
     * ```
     * function(event: object, child?: object) => void
     * ```
     * _event_: The event source of the callback. You can pull out the new value by accessing `event.target.value`.
     *
     * _child_: The react element that was selected
     */
    onChange: _propTypes2.default.func,
    /**
     * Callback fired when the component requests to be closed.
     * Use in controlled mode (see open).
     *
     * Signature:
     * ```
     * function(event: object) => void
     * ```
     * _event_: The event source of the callback
     */
    onClose: _propTypes2.default.func,
    /**
     * Callback fired when the component requests to be opened.
     * Use in controlled mode (see open).
     *
     * Signature:
     * ```
     * function(event: object) => void
     * ```
     *
     * _event_: The event source of the callback
     */
    onOpen: _propTypes2.default.func,
    /**
     * Control `select` open state. You can only use it when the `native` property is `false` (default).
     *
     * If you use `onOpen` or `onClose` callbacks, you must always provide the `open` prop.
     */
    open: _propTypes2.default.bool,
    /**
     * Render the selected value.
     *
     * Signature:
     * ```
     * function(value: any) => ReactElement
     * ```
     *
     * _value_: The `value` provided to the component.
     */
    renderValue: _propTypes2.default.func,
    /**
     * Whether this dropdown is required.
     */
    required: _propTypes2.default.bool,
    /**
     * Properties applied to the clickable div element.
     */
    SelectDisplayProps: _propTypes2.default.object,
    /**
     * Whether to provide a "select all" option for multi-select dropdowns
     */
    showSelectAll: _propTypes2.default.bool,
    /**
     * The input value.
     */
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]))]),
    /**
     * The size of the Dropdown. Small size is recommended to be used within the `TableEditableCell` component.
     */
    size: _propTypes2.default.oneOf(['small', 'medium'])
};

Dropdown.defaultProps = {
    autoWidth: false,
    displayEmpty: false,
    fullWidth: false,
    multiple: false,
    required: false,
    showSelectAll: false,
    size: 'medium',
    value: ''
};
exports.default = (0, _EDSContext.withEDSContext)((0, _styles2.default)(styles)(Dropdown));